let GoogleAuth,
    ACTUAL_SOCIAL,
    socials = {"facebook": "FB", "google": "G"},
    d = document,
    w = window,
    body = document.body,
    docEl = document.documentElement;

if (!String.prototype.startsWith) {
  Object.defineProperty(String.prototype, 'startsWith', {
    enumerable: false,
    configurable: false,
    writable: false,
    value: function (searchString, position) {
      position = position || 0;
      return this.indexOf(searchString, position) === position;
    }
  });
}
if (!String.prototype.endsWith) {
  Object.defineProperty(String.prototype, 'endsWith', {
    value: function (searchString, position) {
      var subjectString = this.toString();
      if (position === undefined || position > subjectString.length) {
        position = subjectString.length;
      }
      position -= searchString.length;
      var lastIndex = subjectString.indexOf(searchString, position);
      return lastIndex !== -1 && lastIndex === position;
    }
  });
}

const $$$ = {
  getTarget(e, selector) {
    return selector ? e.target.closest(selector) : e.target;
  },
  createEl(name, attrs = {}) {
    const el = d.createElement(name);
    for (const key of Object.keys(attrs)) {
      if (key === 'class') {
        if (Array.isArray(attrs[key])) {
          el.classList.add(...attrs[key]);
        } else {
          el.classList.add(attrs[key]);
        }
      } else {
        el.setAttribute(key, attrs[key]);
      }
    }
    return el;
  },
  setHandler(el, event, f) {
    el && el.addEventListener(event, f);
  },
  async api(url, params = {}, method = 'GET', headers = {}) {
    let options = {
      method,
      headers: {
        'Content-Type': 'application/json',
        ...headers
      }
    };

    let queryParams = {};
    let bodyParams = params;

    if (method === 'GET') {
      queryParams = params;
      bodyParams = {};
    } else if (['POST', 'PUT', 'PATCH'].includes(method)) {
      if (params.page !== undefined || params.size !== undefined) {
        queryParams = {page: params.page, size: params.size};
        bodyParams = {...params};
        delete bodyParams.page;
        delete bodyParams.size;
      }
    }

    const queryString = Object.entries(queryParams)
    .filter(([_, v]) => v !== null && v !== undefined)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');

    url += queryString ? `?${queryString}` : '';

    if (Object.keys(bodyParams).length) {
      options.body = JSON.stringify(bodyParams);
    }

    try {
      const response = await fetch(url, options);

      if (!response.ok) {
        let errorMessage = `Error ${response.status}: ${response.statusText}`;
        try {
          const errorData = await response.json();
          errorMessage = `Error ${response.status}: ${errorData.message
          || response.statusText}`;
        } catch (e) {
        }
        throw new Error(errorMessage);
      }

      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        return response.json();
      }

      return null;
    } catch (error) {
      console.error('Request error:', error);
      throw error;
    }
  },
  async upload(url, blob, filename, headers = {}) {
    const formData = new FormData();
    formData.append('audio', blob, filename);

    const response = await fetch(url, {method: 'POST', headers, body: formData});

    if (!response.ok) {
      let errorMessage = `Error ${response.status}: ${response.statusText}`;
      try {
        const errorData = await response.json();
        errorMessage = `Error ${response.status}: ${errorData.error
        || errorData.message || response.statusText}`;
      } catch (e) {
      }
      throw new Error(errorMessage);
    }

    return response.json();
  },
  onrejected(error) {
    console.error(error);
  },
  removeElement: (el) => {
    el && el.parentNode.removeChild(el);
  }
}

var $ = new function Sln() {
  this.getCoords = function (el) {
    var scrollTop = w.pageYOffset || docEl.scrollTop || body.scrollTop;
    var clientTop = docEl.clientTop || body.clientTop || 0;
    return {
      top: el.getBoundingClientRect().top + scrollTop - clientTop,
      left: el.getBoundingClientRect().left,
      height: el.getBoundingClientRect().height
    };
  };
  this.pathContain = function (s) {
    return ~w.location.pathname.search(s);
  };
  this.loader = function (loadFunc, on) {
    return new Loader(loadFunc, on);
  };

  function Loader(cb, on) {
    var block = void 0;
    var ON = on !== false;
    $$$.setHandler(w, "scroll", function () {
      ON && block && (window.pageYOffset || docEl.scrollTop || d.body.scrollTop)
      + d.documentElement.clientHeight >= $.getCoords(block).top
      && (block = null || cb());//todo fix
    });
    this.setBlock = function (newBlock) {
      block = newBlock;
    };
    this.turnOn = function () {
      ON = true;
    };
    this.turnOff = function () {
      ON = false;
    };
  }
}();

function LoginChecker(modal) {
  var loginContainer = d.getElementById("login_container");
  var loginBtn = d.getElementById("login_btn");
  var cbList = [];
  $$$.setHandler(loginBtn, "click", loginBtnClick);
  $$$.setHandler(loginContainer, "click", function (e) {
    $$$.getTarget(e) == loginContainer && !modal && hideLoginBox();
  });
  w.fbAsyncInit = function () {
    FB.init({
      appId: '1201584043315335',
      autoLogAppEvents: true,
      xfbml: true,
      version: 'v19.0',
      status: true,
      cookie: true
    });
    init();
    FB.Event.subscribe('auth.statusChange', auth_status_change_callback);
  };

  this.ginit = function () {
    gapi.load('auth2', function () {
      gapi.auth2.init({
        client_id: '1048263112144-qhsr35724tp429qho7jn9bitlsj2f6li.apps.googleusercontent.com',
        cookiepolicy: 'single_host_origin'
      });
      GoogleAuth = gapi.auth2.getAuthInstance();
    });
    gapi.signin2.render('my-signin2', {
      'scope': 'profile email',
      'width': 236,
      'height': 40,
      'longtitle': true,
      'theme': 'dark',
      'onsuccess': onSuccess,
      'onfailure': onFailure
    });
  };

  function init() {
    FB.getLoginStatus(function (resp) {
      statusChangeCallback(resp, function () {
        onlogin(socials.facebook);
      }, onlogout);
    });
  }

  this.checkLoginStatus = function (tcb, fcb) {
    //todo
    // tcb && tcb({"accessToken": "test-token", "socialName": "FB"})
    checkLoginStatus(tcb, fcb || showLoginBox);
  };

  this.onLoggedIn = function (cb) {
    cbList.push(cb);
  };

  function onSuccess(googleUser) {
    onlogin(socials.google);
  }

  function onFailure(er) {
    console.error(er + ' loginchecker');
  }

  function auth_status_change_callback(resp) {
    resp.status == "connected" ? function () {
      onlogin(socials.facebook);
    }() : function () {
      onlogout(1);
    };
  }

  function onlogin(socialType) {
    ACTUAL_SOCIAL = socialType;
    hideLoginBox();
    loginBtn.innerHTML = "Log out";
    for (var i = cbList.length - 1; i >= 0; i--) {
      checkLoginStatus(cbList[i]);
    }
    cbList = [];
  }

  function onlogout(clear) {
    clear && (ACTUAL_SOCIAL = null);
    loginBtn.innerHTML = "Log in";
  }

  function checkLoginStatus(tcb, fcb) {
    if (ACTUAL_SOCIAL == socials.facebook) {
      FB.getLoginStatus(function (response) {
        if (!response.authResponse) {
          return; //todo fix
        }
        response.authResponse.socialName = "FB";
        statusChangeCallback(response, tcb, fcb);
      });
    } else if (ACTUAL_SOCIAL == socials.google && GoogleAuth.isSignedIn.get()) {
      var idToken = GoogleAuth.currentUser.get().getAuthResponse(true).id_token;
      tcb && tcb({"accessToken": idToken, "socialName": "GOOGLE"});
    } else {
      fcb && fcb();
    }
  }

  function statusChangeCallback(resp, tcb, fcb) {
    resp.status === 'connected' ? tcb && tcb(resp.authResponse) : fcb && fcb();
  }

  function hideLoginBox() {
    loginContainer.style.display = "none";
  }

  function showLoginBox() {
    loginContainer.style.display = "flex";
  }

  function loginBtnClick() {
    checkLoginStatus(logout, showLoginBox);
  }

  function logout() {
    if (ACTUAL_SOCIAL == socials.facebook) {
      FB.logout();
      onlogout(1);
    } else if (ACTUAL_SOCIAL == socials.google) {
      GoogleAuth.signOut();
      onlogout(1);
    }
  }
}

const loginChecker = $.pathContain("cabinet") ? new LoginChecker(true)
    : new LoginChecker();

(function (d, s, id) {
  var js, b = d.getElementsByTagName("body")[0];
  if (d.getElementById(id)) {
    return;
  }
  js = $$$.createEl(s);
  js.id = id;
  js.src = "https://connect.facebook.net/en_US/sdk.js";
  b.insertBefore(js, b.firstChild);
})(d, 'script', 'facebook-jssdk');

(function (d, s) {
  var js, b = d.getElementsByTagName("body")[0];
  js = $$$.createEl(s);
  js.src = "https://apis.google.com/js/platform.js?onload=startApp";
  js.setAttribute("defer", "true");
  js.setAttribute("async", "true");
  b.insertBefore(js, b.firstChild);
})(d, 'script');

function startApp() {
  loginChecker.ginit();
}

//-------------------//

/* new */
(function () {
  'use strict';
  const getDate = (sec) => {
    const date = new Date(sec * 1000);
    const today = new Date();
    if (date.toDateString() === today.toDateString()) {
      return `${date.getHours()}:${date.getMinutes().toString().padStart(2,
          "0")}`;
    }
    return date.toLocaleDateString();
  };
  const getFirstByClassName = (selector, parentElem = document.body) => {
    return parentElem.querySelector(selector);
  }
  const resize = (e) => {
    const target = $$$.getTarget(e);
    target.tagName === "TEXTAREA" && target.clientHeight < target.scrollHeight
    && (target.style.height = target.scrollHeight + "px");
  }
  const loadAvatar = (e) => {
    const img = $$$.getTarget(e);
    if (img.src && !img.src.endsWith(img.dataset.avatar)) {
      img.src = "/img/user-photo/" + img.dataset.avatar;
    }
  };

  const model = {
    saveLocal: (key, obj) => {
      try {
        localStorage.setItem(key, JSON.stringify(obj));
      } catch (error) {
        console.error(error);
      }
    },
    readLocal: (key) => {
      try {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    removeElement: (el) => {
      el && el.parentNode.removeChild(el);
    },
    cani: (key) => {
      if (!model.readLocal(key)) {
        model.saveLocal(key, navigator.userAgent + ":" + Date.now());
      }
      return model.readLocal(key);
    }
  };

  const CLASSIC_VIEW_KEY = 'classic-view';
  const isClassicView = () => model.readLocal(CLASSIC_VIEW_KEY) === true;
  const classicViewHeaders = () => ({'X-Classic-View': isClassicView() ? 'true' : 'false'});

  /*voice dictation*/
  const MIC_ICON_SVG = '<svg class="mic-button__icon" viewBox="0 0 24 24">'
      + '<path d="M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3z"/>'
      + '<path d="M19 11a7 7 0 0 1-14 0H3a9 9 0 0 0 8 8.94V22h2v-2.06A9 9 0 0 0 21 11h-2z"/>'
      + '</svg>';
  const MIC_MAX_DURATION_MS = 120000;
  // getUserMedia is only exposed by the browser in a secure context (HTTPS,
  // or localhost). On an insecure origin navigator.mediaDevices is undefined
  // and the mic button below gets silently removed — which looks exactly
  // like "tapping does nothing" unless it's reported somewhere.
  const micInsecureContext = !w.isSecureContext;
  const micSupported = !micInsecureContext && !!(w.MediaRecorder
      && navigator.mediaDevices && navigator.mediaDevices.getUserMedia);

  // Reports a voice-dictation failure to Sentry (already loaded via the
  // Sentry Loader Script in layout.html) with enough context to diagnose
  // device-specific issues (iOS Safari/Chrome-iOS quirks, permissions, etc.)
  // without needing the user to relay an alert() dialog by hand.
  const reportMicIssue = (messageOrError, extra) => {
    console.error(messageOrError);
    if (!w.Sentry) {
      return;
    }
    const context = {
      tags: {feature: 'voice-dictation'},
      extra: Object.assign({
        userAgent: navigator.userAgent,
        isSecureContext: w.isSecureContext
      }, extra || {})
    };
    messageOrError instanceof Error
        ? Sentry.captureException(messageOrError, context)
        : Sentry.captureMessage(String(messageOrError),
            Object.assign({level: 'warning'}, context));
  };

  // Wires a mic button to record audio, send it to /api/speech/transcribe and
  // insert the returned text into the given textarea. Used both by the main
  // dream composer and by the (dynamically created) comment/reply boxes.
  const attachMic = (micBtn, textarea) => {
    if (!micBtn) {
      return;
    }
    if (!micSupported) {
      reportMicIssue('voice dictation disabled: ' + (micInsecureContext
          ? 'insecure context (getUserMedia requires HTTPS)'
          : 'MediaRecorder/getUserMedia not available in this browser'));
      model.removeElement(micBtn);
      return;
    }

    let recorder, chunks, stream, autoStopTimer;

    const setState = (state) => {
      micBtn.classList.remove('mic-button--recording', 'mic-button--busy');
      state && micBtn.classList.add(state);
    };

    const stopStream = () => {
      stream && stream.getTracks().forEach((track) => track.stop());
      stream = null;
    };

    const insertText = (text) => {
      if (!text) {
        return;
      }
      textarea.value = textarea.value ? `${textarea.value} ${text}` : text;
      textarea.dispatchEvent(new Event('keyup'));
      textarea.focus();
    };

    const transcribe = (blob) => {
      setState('mic-button--busy');
      loginChecker.checkLoginStatus((authResp) => {
        const headers = {
          "app-token": authResp.accessToken,
          "app-social": authResp.socialName
        };
        $$$.upload('/api/speech/transcribe', blob, 'dictation.webm', headers)
        .then((resp) => insertText(resp && resp.text))
        .catch($$$.onrejected)
        .finally(() => setState(null));
      }, () => setState(null));
    };

    const startRecording = () => {
      navigator.mediaDevices.getUserMedia({audio: true})
      .then((mediaStream) => {
        stream = mediaStream;
        chunks = [];
        recorder = new MediaRecorder(stream);
        recorder.ondataavailable = (e) => e.data.size && chunks.push(e.data);
        recorder.onstop = () => {
          stopStream();
          clearTimeout(autoStopTimer);
          if (chunks.length) {
            transcribe(new Blob(chunks, {type: recorder.mimeType || 'audio/webm'}));
          } else {
            setState(null);
          }
        };
        recorder.start();
        setState('mic-button--recording');
        autoStopTimer = setTimeout(() => recorder
                && recorder.state === 'recording' && recorder.stop(),
            MIC_MAX_DURATION_MS);
      })
      .catch((err) => {
        setState(null);
        reportMicIssue(err, {stage: 'getUserMedia'});
      });
    };

    $$$.setHandler(micBtn, 'click', () => {
      if (micBtn.classList.contains('mic-button--busy')) {
        return;
      }
      if (micBtn.classList.contains('mic-button--recording')) {
        recorder && recorder.state === 'recording' && recorder.stop();
        return;
      }
      // getUserMedia must be called synchronously within the click handler —
      // no async step (e.g. the Facebook branch of checkLoginStatus) may sit
      // between the tap and this call, or iOS Safari/Chrome-iOS (both WebKit)
      // silently drop the user-activation gesture and getUserMedia never
      // prompts. Login is still enforced before the recording is uploaded,
      // in transcribe() below.
      startRecording();
    });
  };

  d.addEventListener('DOMContentLoaded', () => {
    const tagsContainer = d.querySelector('[data-tag-list]');
    if (!tagsContainer) {
      return;
    }
    const buildPreview = (p) => {
      const div = $$$.createEl('div', {'class': 'photo-item'});
      const a1 = $$$.createEl('a', {'href': p.url});
      const img = $$$.createEl('img', {
        'class': 'photo-item__img',
        'src': p.photoName
      });
      a1.append(img);
      div.append(a1);
      const div1 = $$$.createEl('div');
      const a2 = $$$.createEl('a', {
        'class': 'photo-item__link',
        'href': p.url
      });
      a2.innerHTML = p.canonicalName;
      div1.append(a2);
      div.append(div1);
      return div;
    }
    const renderTags = (resp) => {
      const content = resp.content;
      const fragment = document.createDocumentFragment();
      for (let i = 0; i < content.length; i++) {
        const preview = content[i];
        const div = buildPreview(preview);
        fragment.appendChild(div)
      }
      tagsContainer.append(fragment);
    }
    const showPreviewList = () => {
      $$$.api('/api/previews/tag', {
        'tagLetter': tagsContainer.dataset.tagList,
        'page': 0,
        'size': 999,
        'sort': 'url'
      }, 'GET', classicViewHeaders())
      .then(renderTags)
      .catch($$$.onrejected);
    }

    const classicToggle = d.getElementById('classic_view_toggle');
    if (classicToggle) {
      classicToggle.checked = isClassicView();
      classicToggle.addEventListener('change', () => {
        model.saveLocal(CLASSIC_VIEW_KEY, classicToggle.checked);
        tagsContainer.innerHTML = '';
        showPreviewList();
      });
    }

    showPreviewList();
  });
  d.addEventListener('DOMContentLoaded', () => {
    const mainContainer = d.querySelector('[data-related]');
    if (!mainContainer) {
      return;
    }
    const renderRelatedTags = (p) => {
      const a = $$$.createEl('a', {
        'class': 'related-tags__item',
        'href': p.url
      });
      const img = $$$.createEl('img', {
        'class': 'lazyload',
        'data-src': p.photoName
      });
      const span = $$$.createEl('span');
      span.innerHTML = p.canonicalName;
      a.append(img);
      a.append(span);
      return a;
    }
    const renderRelatedArticles = (p) => {
      const a = $$$.createEl('a', {
        'class': 'popular-dreams__item',
        'href': p.url
      });
      const img = $$$.createEl('img', {
        'class': ["popular-dreams__img", "lazyload"],
        'data-src': p.photoName
      });
      const span = $$$.createEl('span');
      span.innerHTML = p.title;
      a.append(img);
      a.append(span);
      return a;
    }
    const renderPreviews = (previews) => {
      let tagsContainer, articleContainer;
      const fragment = document.createDocumentFragment();
      const tags = previews.tags;
      for (let i = 0; i < tags.length; i++) {
        const tag = tags[i];
        tagsContainer || (tagsContainer = $$$.createEl('div',
            {'class': 'related-tags'}));
        tagsContainer.append(renderRelatedTags(tag));
      }
      const tagsBlock = attachTagsContainer(tagsContainer);
      tagsBlock && fragment.appendChild(tagsBlock);

      const articles = previews.articles;
      for (let i = 0; i < articles.length; i++) {
        const article = articles[i];
        articleContainer || (articleContainer = $$$.createEl('div',
            {'class': 'popular-dreams'}));
        articleContainer.append(renderRelatedArticles(article));
      }
      const articlesBlock = attachArticleContainer(articleContainer);
      articlesBlock && fragment.appendChild(articlesBlock);

      (tagsBlock || articlesBlock) && mainContainer.append(fragment);
    }
    const attachTagsContainer = (tagsContainer) => {
      if (!tagsContainer) {
        return null;
      }
      const div = $$$.createEl('div');
      const h3 = $$$.createEl('h3');
      h3.innerHTML = 'Related Dreams:';

      div.append(h3);
      div.append(tagsContainer);
      return div;
    }
    const attachArticleContainer = (articleContainer) => {
      if (!articleContainer) {
        return null;
      }
      const div = $$$.createEl('div');

      const h3 = $$$.createEl('h3');
      h3.innerHTML = 'Related articles:';

      div.append(h3);
      div.append(articleContainer);

      return div;
    }
    const renderRelated = () => {
      const articleId = mainContainer.dataset.related;
      $$$.api('/api/previews/related', {articleId}, 'GET', classicViewHeaders())
      .then(renderPreviews)
      .catch($$$.onrejected);
    }

    renderRelated();
  });
  d.addEventListener('DOMContentLoaded', () => {
    const container = d.getElementById('page_type');
    if (!container) {
      return;
    }
    let pageType = container.dataset.pageType,
        page = 0,
        omenGroupId = null;

    const previewRenderer = (list) => {
      let lastBlock = null;
      for (let i = 0; i < list.length; i++) {
        const preview = list[i];
        lastBlock = $$$.createEl('div', {'class': 'shadow'});
        lastBlock.innerHTML = '<div class="in-shadow"><a href="' + preview.url
            + '"><img class="art" src="' + preview.photoName
            + '"/></a><div><h3>' + preview.title + '</h3><p>'
            + preview.snippet
            + ' <a href="' + preview.url
            + '">Read more...</a></p></div></div>';
        container.append(lastBlock);
      }
      list.length === 30 && articlePreloader.setBlock(lastBlock);
    }
    const articleLoader = () => {
      $$$.api('/api/previews/article', {
        'size': 30,
        'sort': 'order,desc',
        omenGroupId,
        pageType,
        page
      }, 'GET', classicViewHeaders())
      .then(r => {
        previewRenderer(r);
        page += 1;
      })
      .catch($$$.onrejected);
    }
    const articlePreloader = $.loader(articleLoader);
    const renderOmenGroups = (groups) => {
      const showGroup = (e) => {
        const {target} = e;
        const id = target.dataset.id;
        if (id) {
          container.innerHTML = "";
          page = 0;
          omenGroupId = id;
          articleLoader();
        }
      }
      const groupContainer = document.querySelector('#omen_groups');
      groupContainer.addEventListener('click', showGroup);

      groups.forEach(function (item) {
        const div = $$$.createEl('div', {'data-id': item.id});
        div.innerHTML = item.name;
        groupContainer.append(div);
      });
    }

    articleLoader();

    pageType === "OMENS" && $$$.api("/api/omen_groups/get")
    .then(renderOmenGroups)
    .catch($$$.onrejected);
  });
  d.addEventListener('DOMContentLoaded', () => {
    const cup = d.getElementById('leader_cup');
    if (!cup) {
      return;
    }
    let board = null;

    const showLeaderBoard = () => {
      const renderItem = (user, board) => {
        const item = $$$.createEl('div');
        const img = $$$.createEl('img', {
          'class': 'user-data__photo',
          'data-avatar': user.photoDefault,
          'src': user.photo
        })
        img.onerror = loadAvatar;

        const span = $$$.createEl('span');
        span.innerHTML = user.userName + " - " + user.score;

        item.append(img);
        item.append(span);

        board.append(item);
      }
      const renderBoard = (leaders) => {
        board = d.getElementById('leader_board');
        const h4 = $$$.createEl('h4');

        h4.innerHTML = 'Top active users:';
        board.append(h4);

        leaders.forEach((item) => renderItem(item, board));

        board.style.display = 'block';
      }

      if (!board) {
        $$$.api('/api/leader-board')
        .then(renderBoard)
        .catch($$$.onrejected);
      } else {
        board.style.display = board.style.display === 'block' ? 'none'
            : 'block'
      }
    }

    cup.addEventListener('click', showLeaderBoard);
  });
  d.addEventListener('DOMContentLoaded', () => {
    const randomPollBlock = document.querySelector('[data-random-poll]');
    const archivePollBlock = document.querySelector('#archive_list');
    const polls = model.readLocal('poll') || [];
    const createPollWidget = (poll) => {
      const canBeVoted = !~polls.indexOf(poll.pollId);
      const widget = $$$.createEl('div', {
        'class': 'poll-widjet',
        'data-poll-id': poll.pollId
      });
      const opts = (options) => {
        let res = '';
        for (let key in options) {
          if (canBeVoted) {
            res += '<div class="p-answer"><label><input type="radio" data-ans-id="'
                + key + '" name="poll"> - ' + options[key].option
                + '</label></div>';
          } else {
            res += '<div class="p-answer"><div>' + options[key].option
                + '</div><div><b>' + options[key].votes + '</b> ('
                + Math.round(options[key].votes / poll.voted * 100)
                + '%)</div></div>';
          }
        }
        return res;
      }

      let inner = '<h3>' + poll.question + '</h3>';
      inner += '<div id="poll_block">' + opts(poll.options) + '</div>';
      canBeVoted
      && (inner += '<div id="poll_btn" class="poll-vote-btn">Vote</div>');
      randomPollBlock
      && (inner += '<a href="/polls-archive" class="app-button">Polls archive</a>');
      inner += '<div>votes: ' + poll.voted + '</div>';

      widget.innerHTML = inner;
      return widget;
    }
    const appendPolls = (container, polls) => {
      polls.map(createPollWidget).forEach(poll => container.append(poll));
    };
    const vote = (e) => {
      const {target} = e;
      if (!target.classList.contains('poll-vote-btn')) {
        return;
      }
      const showResult = (pollResult, pollWidget) => {
        const pollId = pollResult.pollId;
        if (!~polls.indexOf(pollId)) {
          polls.push(pollId);
          model.saveLocal('poll', polls);
        }
        pollWidget.replaceWith(createPollWidget(pollResult));
      }
      const pollWidget = target.closest('.poll-widjet');
      const checkedInputs = pollWidget.querySelectorAll('input:checked');
      if (checkedInputs.length > 0) {
        const checked = checkedInputs.item(0);
        const pollId = pollWidget.dataset.pollId;
        const answerId = checked.dataset.ansId;
        $$$.api('/api/poll/vote', {pollId, answerId}, 'POST')
        .then((pollResult) => showResult(pollResult, pollWidget))
        .catch($$$.onrejected);
      }
    }

    if (randomPollBlock) {
      randomPollBlock.addEventListener('click', vote);
      $$$.api('/api/poll/random', {'votedIds': polls})
      .then((poll) => appendPolls(randomPollBlock, [poll]))
      .catch($$$.onrejected);
    } else if (archivePollBlock) {
      archivePollBlock.addEventListener('click', vote);
      $$$.api('/api/poll/list')
      .then((polls) => appendPolls(archivePollBlock, polls))
      .catch($$$.onrejected);
    }
  });
  d.addEventListener('DOMContentLoaded', () => {
    const ratingBlock = d.getElementById('rating_result');
    if (!ratingBlock) {
      return;
    }
    const segments = location.pathname.split('/');
    const url = segments[segments.length - 1];
    const rateSetup = (resp) => {
      let rate = parseFloat(resp.rating.replace(',', '.'));
      d.getElementById('rating_val').innerHTML = `${rate} (${resp.votes})`;
      const stars = d.querySelectorAll(".inner");
      for (let i = 0; i < stars.length; i++, rate--) {
        const star = stars[i];
        if (rate > 0) {
          star.style.width = (rate > 1)
              ? '30px'
              : 30 * (Math.asin(2 * rate - 1) / Math.PI + 0.5) + 'px';
        } else {
          star.style.width = '0px';
        }
      }

    }
    const handleVote = (e) => {
      const {target} = e;
      const starClicked = target.closest('.outer');
      if (!starClicked) {
        return;
      }
      const stars = starClicked.dataset.star;
      const pageType = ratingBlock.dataset.pageType;
      const browserTrack = model.cani('page-voter');
      const fprint = url + "|" + pageType + "|" + browserTrack;
      $$$.api('/api/rating', {stars, url, pageType, browserTrack}, 'POST')
      .then(rateSetup)
      .catch($$$.onrejected);
    }
    const showRate = () => {
      $$$.api('/api/rating', {url})
      .then(rateSetup)
      .catch($$$.onrejected);
    }

    showRate();
    ratingBlock.addEventListener('click', handleVote);
  });
  d.addEventListener('DOMContentLoaded', () => {
    const cookieContainer = d.querySelector('.fortune-cookie-container');
    const tk = new Date().toDateString();
    if (!cookieContainer || model.readLocal('fortunecookie') === tk) {
      return;
    }
    cookieContainer.style.display = 'block';
    const showCookie = () => {
      d.getElementById('fca').className = 'fortune-cookie_frozen';
      const txtContainer = d.getElementById('fortune');
      txtContainer.className = 'fortune-cookie__text_visible';
      $$$.api('/api/fortunecookie')
      .then(resp => txtContainer.innerHTML = resp.text)
      .catch($$$.onrejected);
      model.saveLocal('fortunecookie', tk);
    }

    cookieContainer.addEventListener('click', showCookie);
  });
  d.addEventListener('DOMContentLoaded', () => {
    const vinkies = d.getElementById('vinkies');
    if (!vinkies) {
      return;
    }
    const vinkeyMap = {
      "28": "joyful",
      "21": "angry",
      "15": "crying",
      "12": "shocked",
      "2": "thoughtful"
    }
    const changeVinky = (e) => {
      const {target} = e;
      if (target.tagName === "IMG") {
        d.querySelector(
            "#theme-name").innerHTML = vinkeyMap[target.dataset.name];
        d.querySelector("#vinky").src = target.src;
        vinkies.style.display = "none";
      }
    }

    d.getElementById('dream-theme').addEventListener('click',
        () => vinkies.style.display = "block");
    vinkies.addEventListener('click', changeVinky);
  });
  d.addEventListener('DOMContentLoaded', () => {
    const articleSource = d.querySelector(".collab-text");
    const postBtn = d.querySelector(".collab-post-btn");
    const postCollab = () => {
      loginChecker.checkLoginStatus((authResp) => {
        const text = articleSource.value;
        if (!text.trim()) {
          return;
        }
        const headers = {
          "app-token": authResp.accessToken,
          "app-social": authResp.socialName
        }
        $$$.api('/api/collab', {text}, 'POST', headers)
        .then(() => articleSource.value = '')
        .catch($$$.onrejected);
      });
    }

    $$$.setHandler(articleSource, 'keyup', resize);
    $$$.setHandler(postBtn, 'click', postCollab);
  });
  d.addEventListener('DOMContentLoaded', () => {
    const rateUp = (e) => {
      const uid = model.cani('fact-voter');
      const target = uid && $$$.getTarget(e, ".of-like");
      if (!target) {
        return;
      }
      const factId = target.id;
      const counterUp = () => {
        const rateBlock = target.nextElementSibling;
        rateBlock.innerText = "+" + (+rateBlock.innerText + 1);
      }
      $$$.api('/api/facts/rate/', {factId, uid}, 'POST')
      .then(() => counterUp())
      .catch($$$.onrejected);
    }
    location.pathname.startsWith("/facts") && $$$.setHandler(d.body, "click",
        rateUp);
  });
  d.addEventListener('DOMContentLoaded', () => {
    const delAccBox = d.getElementById("loader_del_acc");
    const hideDelBox = () => {
      delAccBox && (delAccBox.style.display = "none");
    }
    const showDelBox = () => {
      delAccBox && (delAccBox.style.display = "block");
    }
    const deleteUserData = () => {
      loginChecker.checkLoginStatus((authResp) => {
        const headers = {
          "app-token": authResp.accessToken,
          "app-social": authResp.socialName
        }
        $$$.api("/api/cabinet/delete-user-data", null, "DELETE", headers)
        .then(() => w.location.href = "/")
        .catch($$$.onrejected);
      });
    }

    $$$.setHandler(d.getElementById("acc_del"), "click", showDelBox);
    $$$.setHandler(d.getElementById("cancel_del_acc"), "click", hideDelBox);
    $$$.setHandler(d.getElementById("confirm_del_acc"), "click",
        deleteUserData);

  });
  d.addEventListener('DOMContentLoaded', () => {
    const corner = d.getElementById("stop-war");
    if (corner && !model.readLocal("ptnpnh")) {
      corner.style.display = "flex";
      $$$.setHandler(corner, "click", () => {
        corner.style.display = "none";
        model.saveLocal("ptnpnh", Date.now());
      });
    }
  });
  d.addEventListener('DOMContentLoaded', () => {
    const commentContainer = d.getElementById("widjet_comment_list");
    if (!commentContainer) {
      return;
    }
    const isCommonDreamPage = () => $.pathContain("/shared_dreams/show");
    const renderPublisher = () => {
      const div = $$$.createEl('div',
          {'class': ["poster", "post-publisher"]});
      div.innerHTML = '<textarea class="post-source" placeholder="Add a comment..."></textarea>'
          + '<div class="mic-button" title="Dictate by voice">' + MIC_ICON_SVG + '</div>'
          + '<div class="poster-btn app-button">Post</div>';
      commentContainer.appendChild(div);
      attachMic(div.querySelector('.mic-button'), div.querySelector('.post-source'));
    }

    let hiddenVoteBlock, replier, dreamPreloader, page = 0;
    const postProvider = (callback) => {
      $$$.api('/api/post', {"url": w.location.pathname, page})
      .then(callback)
      .then(() => page++)
      .catch($$$.onrejected);
    }
    const renderPost = (resp) => {
      const commentBlock = $$$.createEl('div');
      commentBlock.className = resp.replied_to ? "sub-comment" : "root-comment";
      commentBlock.dataset.commentId = resp.comment_id;
      commentBlock.innerHTML =
          '<div class="user-data-block">'
          + '<div class="user-data">'
          + '<img class="user-data__photo" data-avatar="' + resp.user.photo_err
          + '" src="' + resp.user.photo + '">'
          + '<div class="user-data__name"><b>' + resp.user.name + '</b>'
          + (resp.replied_to
              ? '<div class="user-data__reply-to-block"><img class="user-data__reply-to-img" src="/img/reply.svg"><b>'
              + resp.replied_to
              + '</b></div>' : '')
          + '</div>'
          + '</div>'
          + (resp.vinky_url ? '<img class="vinky" src="' + resp.vinky_url + '">'
              : '')
          + '<div><span class="my-date">' + getDate(resp.created)
          + '</span></div>'
          + '</div>'

          + '<div class="post-content">'
          + resp.comment_text
          + '</div>'

          + '<div class="upvote-block">'
          + '<div class="reply-button app-button">Reply</div>'
          + '<div class="post-upvote-button app-button" data-comment-id="'
          + resp.comment_id
          + '"><span>Upvote: </span><span class="upvote-value">'
          + resp.likes + '</span></div>'
          + '</div>';
      return commentBlock;
    }
    const commentReceiver = (e) => {
      const target = $$$.getTarget(e, '.post-more');
      if (target) {
        const rootPostId = target.dataset.rootId;
        if (rootPostId) {
          $$$.api('/api/comment', {rootPostId})
          .then(comments => {
            const targetParent = target.closest(".read-more");
            const parentEl = targetParent.parentNode;
            const beforeEl = targetParent.nextSibling || null;
            model.removeElement(targetParent);
            comments.forEach((comment) => {
              const commentBlock = renderPost(comment);
              parentEl.insertBefore(commentBlock, beforeEl);
              dreamPreloader && dreamPreloader.setBlock(commentBlock);
            });
          })
          .catch($$$.onrejected);
        } else {
          postProvider((packet) => {
            renderPostList(packet);
            model.removeElement(target.closest('.read-more'));
          });
        }
      }
    }
    const renderPostList = (packet) => {
      packet.root_comments.forEach(function (post) {
        const commentBlock = renderPost(post);
        commentContainer.appendChild(commentBlock);
        dreamPreloader && dreamPreloader.setBlock(commentBlock);

        const tiedComments = packet.first_comments.filter((comment) => {
          return comment.commented_id === post.comment_id;
        });
        if (tiedComments.length) {
          const latestComment = tiedComments[0];
          const commentBlock = renderPost(latestComment);
          commentContainer.appendChild(commentBlock);
          dreamPreloader && dreamPreloader.setBlock(commentBlock);
          post.comment_count > 1 && renderReadMore(post.comment_id,
              commentContainer);
        }
      });
      if (packet.has_more) {
        packet.is_dream === false && renderReadMore(null, commentContainer);
      } else {
        dreamPreloader && dreamPreloader.turnOff();
      }
    }
    const renderReadMore = (rootId, parent) => {
      const div = $$$.createEl('div', {'class': 'read-more'});
      if (!rootId) {
        div.innerHTML = '<svg class="svg-arrow"><g><path d="M15.7,1.9c0.4-0.4,0.4-1.2,0-1.6c-0.4-0.4-1.2-0.4-1.6,0l-6,6l-6-6c-0.4-0.4-1.2-0.4-1.6,0C0.1,0.5,0,0.8,0,1.1c0,0.3,0.1,0.6,0.3,0.8l6.9,6.7c0.4,0.4,1.2,0.4,1.6,0L15.7,1.9z"></path></g></svg>';
      }
      const span = $$$.createEl('span', {'class': 'post-more'});
      span.innerText = rootId ? 'Read more replies...'
          : (w.location.pathname.startsWith("/shared_dreams")
              ? 'Read more dreams'
              : 'Read more comments');
      div.appendChild(span);
      rootId && (span.dataset.rootId = rootId);
      parent.appendChild(div);
    }
    const renderReplierBlock = (commentedId, before) => {
      const replierBlock = $$$.createEl("div",
          {
            'class': ['comment-publishing-block', 'post-publisher'],
            'data-commented-id': commentedId
          });

      const textarea = $$$.createEl("textarea",
          {
            'class': 'post-source',
            'data-commented-id': commentedId
          });
      textarea.placeholder = "Add a comment...";
      const micBtn = $$$.createEl('div',
          {'class': 'mic-button', 'title': 'Dictate by voice'});
      micBtn.innerHTML = MIC_ICON_SVG;
      const cancelBtn = $$$.createEl('div',
          {'class': ['cancel-reply', 'app-button']});
      cancelBtn.innerHTML = "Cancel";
      const publishBtn = $$$.createEl('div',
          {
            'class': ['publish-reply-dream-btn', 'app-button', 'poster-btn'],
            'data-commented-id': commentedId
          });
      publishBtn.innerHTML = "Post";

      replierBlock.appendChild(textarea);
      replierBlock.appendChild(micBtn);
      replierBlock.appendChild(cancelBtn);
      replierBlock.appendChild(publishBtn);

      commentContainer.insertBefore(replierBlock, before || null);
      attachMic(micBtn, textarea);
      return replierBlock;
    }
    const reply = (e) => {
      const target = $$$.getTarget(e, '.reply-button');
      if (target) {
        const commented = target.closest('.root-comment')
            || target.closest('.sub-comment');
        replier = renderReplierBlock(commented.dataset.commentId,
            commented.nextSibling);
        hiddenVoteBlock = getFirstByClassName('.upvote-block', commented);
        hiddenVoteBlock.style.display = 'none';
      }
    }
    const upvote = (e) => {
      var target = $$$.getTarget(e, ".post-upvote-button");
      target && loginChecker.checkLoginStatus((authResp) => {
        const headers = {
          "app-token": authResp.accessToken,
          "app-social": authResp.socialName
        }
        const postId = +target.dataset.commentId;
        return $$$.api("/api/post/upvote", {postId}, 'POST', headers)
        .then(() => {
          var rate = getFirstByClassName(".upvote-value", target);
          rate.innerHTML = ++rate.innerHTML;
        })
        .catch($$$.onrejected);
      });
    }
    const showUpvoteBlock = () => {
      model.removeElement(replier);
      replier = null;
      if (hiddenVoteBlock) {
        hiddenVoteBlock.style.display = "flex";
        hiddenVoteBlock = null;
      }
    }
    const post = (e) => {
      const target = $$$.getTarget(e, ".poster-btn");
      target && loginChecker.checkLoginStatus(
          (authResp) => postAuth(target, authResp));
    }
    const postAuth = (target, authResp) => {
      const poster = target.closest(".post-publisher");
      const source = getFirstByClassName('.post-source', poster);
      const commentText = source.value;
      const commentedId = +poster.dataset.commentedId;
      const url = w.location.pathname;
      const headers = {
        "app-token": authResp.accessToken,
        "app-social": authResp.socialName
      }
      $$$.api('/api/post', {url, commentText, commentedId}, 'POST', headers)
      .then((post) => {
        const commentBlock = renderPost(post);
        commentContainer.insertBefore(commentBlock, poster.nextSibling || null);
        if (commentedId) {
          showUpvoteBlock();
        } else {
          source.value = null;
        }
      })
      .catch($$$.onrejected);
    }
    const toggleUpvoteBlock = (e) => {
      const cancelReplyTarget = $$$.getTarget(e, ".cancel-reply");
      if (cancelReplyTarget) {
        showUpvoteBlock();
      }
    }

    if (isCommonDreamPage()) {
      dreamPreloader = $.loader(() => postProvider(renderPostList));
    } else {
      renderPublisher();
    }

    postProvider(renderPostList);

    $$$.setHandler(commentContainer, "click", commentReceiver);
    $$$.setHandler(commentContainer, 'keyup', resize);
    $$$.setHandler(commentContainer, 'click', reply);
    $$$.setHandler(commentContainer, 'click', upvote);
    $$$.setHandler(commentContainer, 'click', post);
    $$$.setHandler(commentContainer, 'click', toggleUpvoteBlock);
  });
  d.addEventListener('DOMContentLoaded', () => {
    if (!w.location.pathname.startsWith("/my-cabinet")) {
      return;
    }
    let postPage = 0, hasMorePost = true;
    let replyPage = 0, hasMoreReply = true;
    const getPost = (isReply) => {
      const hasMore = isReply ? hasMoreReply : hasMorePost
      hasMore && loginChecker.checkLoginStatus((authResp) => {
        const renderPosts = (resp) => {
          isReply ? (hasMoreReply = resp.hasMore)
              : (hasMorePost = resp.hasMore);
          const posts = resp.posts;
          const postContainer = isReply
              ? d.getElementById("personal_reply_list")
              : d.getElementById("personal_post_container");
          const activeLoader = isReply ? rloader : ploader;
          const buildPostBlock = (post, isReply) => {
            const postContainer = $$$.createEl('div',
                {
                  'class': 'widjet-dream',
                  'id': post.comment_id,
                  'isPost': post.is_post,
                  'isReply': isReply
                });
            const createUserDataBlock = (post) => {
              const createUserBlock = (post) => {
                const createReplyToBlock = (post) => {
                  const img = $$$.createEl('img',
                      {
                        'class': 'user-data__reply-to-img',
                        'src': '/img/reply.svg'
                      });
                  const b = $$$.createEl('b');
                  b.innerHTML = post.replied_to;

                  const container = $$$.createEl("div",
                      {'class': 'user-data__reply-to-block'});
                  container.appendChild(img);
                  container.appendChild(b);
                  return container;
                }
                const container = $$$.createEl('div', {'class': 'user-data'});
                const userPhoto = $$$.createEl('img', {
                  'class': 'user-data__photo',
                  'data-avatar': post.user.photo_err,
                  'src': post.user.photo || '/img/user-photo/anon.jpg'
                });
                userPhoto.onerror = loadAvatar;

                const bUserName = $$$.createEl('b');
                bUserName.innerHTML = post.user.name;

                const div = $$$.createEl('div', {'class': 'user-data__name'});
                div.appendChild(bUserName);
                post.replied_to && div.appendChild(createReplyToBlock(post));

                container.appendChild(userPhoto);
                container.appendChild(div);
                return container;
              }
              const createDateBlock = (post) => {
                const span = $$$.createEl('span', {'class': 'my-date'});
                span.innerHTML = getDate(post.created);
                const div = $$$.createEl('div');
                div.appendChild(span);
                return div;
              }
              const container = $$$.createEl('div',
                  {'class': 'user-data-block'});

              container.appendChild(createUserBlock(post));
              container.appendChild(createDateBlock(post));
              return container;
            }
            const createContentBlock = (post) => {
              const content = $$$.createEl('div');
              content.innerHTML = post.comment_text;
              return content;
            }
            const createRedirectBlock = (post) => {
              const container = $$$.createEl('div',
                  {'class': 'upvote-block'});
              const redirectBtn = $$$.createEl('div',
                  {
                    'class': ['redirect', 'app-button'],
                    'data-comment-id': post.comment_id,
                    'data-is-post': post.is_post,
                    'data-is-reply': isReply,
                    'data-dream-id': post.dream_id,
                    'data-url': post.url
                  });
              redirectBtn.innerHTML = 'View';

              container.appendChild(redirectBtn);
              return container;
            }

            postContainer.appendChild(createUserDataBlock(post));
            postContainer.appendChild(createContentBlock(post));
            postContainer.appendChild(createRedirectBlock(post));
            return postContainer;
          }

          activeLoader.setBlock(null)
          posts.forEach(function (p) {
            const postBlock = buildPostBlock(p, isReply);
            const appended = postContainer.appendChild(postBlock);
            activeLoader.setBlock(appended);
          });
        }
        const headers = {
          "app-token": authResp.accessToken,
          "app-social": authResp.socialName
        }
        const page = isReply ? replyPage : postPage;
        $$$.api('/api/personal/posts', {page, isReply}, 'GET', headers)
        .then(renderPosts)
        .then(() => {
          if (isReply) {
            replyPage += 1
          } else {
            postPage += 1
          }
        })
        .catch($$$.onrejected);
      });
    };

    const ploader = $.loader(() => getPost(false), true);
    const rloader = $.loader(() => getPost(true), true);
    const redirect = (e) => {
      const target = $$$.getTarget(e, ".redirect");
      if (target) {
        const isReply = target.dataset.isReply === "true";
        const isPost = target.dataset.isPost === "true";
        const dreamUrl = "/shared_dreams/" + target.dataset.dreamId;
        const commentUrl = target.dataset.url + "#widjet_comment_list";
        w.location.href = (isReply && !isPost) ? dreamUrl : commentUrl;
      }
    };
    const show = (e) => {
      var target = $$$.getTarget(e, ".nav-block_white");
      if (target) {
        const blockId = target.dataset.blockId;
        const tabList = d.getElementsByClassName("cab_tab");
        const navList = d.getElementsByClassName("nav-block_white");
        const changeTab = (blockId) => {
          for (let i = 0; i < navList.length; i++) {
            navList[i].style.backgroundColor = navList[i].dataset.blockId
            == blockId ? "#a7ab57" : "";
          }
          for (let _i = 0; _i < tabList.length; _i++) {
            tabList[_i].style.height = tabList[_i].id == blockId ? "auto"
                : "";
          }
          d.documentElement.scrollTop = 0;
        }
        const showGuestPosts = () => {
          const renderGuestPosts = (guestPosts) => {
            const container = d.getElementById('guest_post_list');
            const fragment = d.createDocumentFragment();
            const ul = $$$.createEl('ul');

            for (let i = 0; i < guestPosts.length; i++) {
              const guestPost = guestPosts[i];
              const li = $$$.createEl('li');
              const a = $$$.createEl('a', {'href': guestPost.url});
              a.innerHTML = guestPost.title;
              li.appendChild(a);
              ul.appendChild(li);
            }

            fragment.appendChild(ul);
            container.innerHTML = '';
            container.appendChild(fragment);
          }
          loginChecker.checkLoginStatus((authResp) => {
            const headers = {
              "app-token": authResp.accessToken,
              "app-social": authResp.socialName
            }
            $$$.api('/api/collab', {}, 'GET', headers)
            .then(renderGuestPosts)
            .catch($$$.onrejected);
          });
        }
        const showBookmarks = () => {
          const renderBookmarks = (bookmarks) => {
            const container = d.getElementById('bookmark_list');
            const fragment = d.createDocumentFragment();
            const ul = $$$.createEl('ul');

            for (let i = 0; i < bookmarks.length; i++) {
              const bookmark = bookmarks[i];
              const li = $$$.createEl('li');
              const a = $$$.createEl('a', {'href': bookmark.url});
              a.innerHTML = bookmark.title;
              li.appendChild(a);
              ul.appendChild(li);
            }

            fragment.appendChild(ul);
            container.innerHTML = '';
            container.appendChild(fragment);
          }
          loginChecker.checkLoginStatus((authResp) => {
            const headers = {
              "app-token": authResp.accessToken,
              "app-social": authResp.socialName
            }
            $$$.api('/api/article/bookmarks/personal', {}, 'GET', headers)
            .then(renderBookmarks)
            .catch($$$.onrejected);
          });
        }
        if (blockId === "leave") {
          w.location.href = '/shared_dreams/show';
        }
        if (blockId === "b3") {
          showGuestPosts();
        }
        if (blockId === "b4") {
          showBookmarks();
        }
        changeTab(blockId);
      }
    };

    $$$.setHandler(d.body, "click", show);
    $$$.setHandler(d.body, "click", redirect);

    loginChecker.checkLoginStatus();
    loginChecker.onLoggedIn(() => getPost(false));
    loginChecker.onLoggedIn(() => getPost(true));
  });
  d.addEventListener('DOMContentLoaded', () => {
    const publisherBlock = d.getElementById('publisher_block');
    if (!publisherBlock) {
      return;
    }
    const progress = (() => {
      const loader = document.getElementById("loader-1");
      return {
        show: () => loader && (loader.style.display = "block"),
        hide: () => loader && (loader.style.display = "none")
      };
    })();
    const publishDreamBtn = d.getElementById("publish_dream");
    const publishCancelBtn = d.getElementById("publish_dream_cancel");
    const dreamSource = d.getElementById("dream_source");
    const dreamMicBtn = d.getElementById("dream_mic_btn");

    const prefillPost = () => {
      const initSource = (text) => {
        publisherBlock.style.display = "block";
        dreamSource.value = text;
        dreamSource.clientHeight < dreamSource.scrollHeight
        && (dreamSource.style.height = dreamSource.scrollHeight + "px");
      }
      const q = decodeURI(w.location.href).replace(/.+q=/g, "").replace(/&.+/g,
          "").replace(/%2C/g, ",").replace(/%3F/g, "?");
      q.length > 120 && initSource(q);
    }
    if ($.pathContain("search-result")) {
      prefillPost();
    }

    const sendNewDream = () => {
      dreamSource.value && loginChecker.checkLoginStatus(
          (authResp) => {
            progress.show();
            const headers = {
              "app-token": authResp.accessToken,
              "app-social": authResp.socialName
            }
            const url = 'shared_dreams';
            const commentText = dreamSource.value;
            const dreamGenre = d.getElementById('theme-name')
            .innerHTML.toUpperCase().replace('!', '');
            $$$.api('/api/post', {url, commentText, dreamGenre}, 'POST',
                headers)
            .then(() => {
              w.location.href = "/shared_dreams/show";
            })
            .catch((err) => progress.hide());
          });
    }
    const showDreamBtnBlock = () => {
      loginChecker.checkLoginStatus(
          () => dreamSource.classList.add('dream_source_show'));
    }
    const cancelDreamBtnBlock = () => {
      dreamSource.value = '';
      dreamSource.classList.remove('dream_source_show');
    }

    $$$.setHandler(dreamSource, 'keyup', resize);
    $$$.setHandler(dreamSource, "focus", showDreamBtnBlock);
    $$$.setHandler(publishCancelBtn, "click", cancelDreamBtnBlock);
    $$$.setHandler(publishDreamBtn, "click", sendNewDream);
    attachMic(dreamMicBtn, dreamSource);
  });

  d.addEventListener('DOMContentLoaded', () => {
    const articleViews = d.querySelector('.articleViews');
    if (!articleViews) {
      return;
    }
    const renderViews = ({viewed}) => {
      articleViews.innerHTML = viewed
    }

    const url = location.pathname;
    $$$.api('/api/article/views', {url})
    .then(renderViews)
    .catch($$$.onrejected);
  });

  d.addEventListener('DOMContentLoaded', () => {
    const url = location.pathname
    $$$.api('/api/article/views', {url}, 'POST')
    .catch($$$.onrejected);
  });

  d.addEventListener('DOMContentLoaded', () => {
    const toggleBookmark = () => {
      d.querySelectorAll(".article-info_block__icon")
      .forEach(
          icon => icon.classList.toggle('article-info_block__icon--active'));
    }
    const checkBookmark = () => {
      const turnOn = (resp) => {
        resp.added && toggleBookmark();
      }
      loginChecker.checkLoginStatus(
          (authResp) => {
            const headers = {
              "app-token": authResp.accessToken,
              "app-social": authResp.socialName
            }
            const url = location.pathname;
            $$$.api('/api/article/bookmarks', {url}, 'GET', headers)
            .then(turnOn)
            .catch($$$.onrejected);
          }, x => x);
    }
    const addBookmark = () => {
      toggleBookmark();
      const activeIcon = d.querySelector('.article-info_block__icon--active');
      const added = activeIcon.dataset.bookmark === 'on';
      loginChecker.checkLoginStatus(
          (authResp) => {
            const headers = {
              "app-token": authResp.accessToken,
              "app-social": authResp.socialName
            }
            const url = location.pathname;
            $$$.api('/api/article/bookmarks', {url, added}, 'POST', headers)
            .catch($$$.onrejected);
          });
    }
    loginChecker.onLoggedIn(() => checkBookmark());

    $$$.setHandler(d.querySelector(".article-info"), 'click', addBookmark);
  });
})();

